import { render, staticRenderFns } from "./FourthTable.vue?vue&type=template&id=adc9c1d6&"
import script from "./FourthTable.vue?vue&type=script&lang=js&"
export * from "./FourthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports